import { render } from "./BaseDataMaterial.vue?vue&type=template&id=3e73ff5e"
import script from "./BaseDataMaterial.vue?vue&type=script&lang=js"
export * from "./BaseDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__